export const asHourGlass = {
  data: `<svg width="8" height="14" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0.333008V4.33301H0.00666682L0 4.33967L2.66667 6.99967L0 9.66634L0.00666682 9.67301H0V13.6663H8V9.67301H7.99333L8 9.66634L5.33333 6.99967L8 4.33967L7.99333 4.33301H8V0.333008H0ZM6.66667 9.99967V12.333H1.33333V9.99967L4 7.33301L6.66667 9.99967ZM4 6.66634L1.33333 3.99967V1.66634H6.66667V3.99967L4 6.66634Z"/>
  </svg>`,
  name: 'hourglass',
};
